import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getCollectionIdAndPatternOfCurrentDynamicPage } from './getCollectionIdAndPatternOfCurrentDynamicPage'
import { isCategoryCollection } from '../../collections/collectionTypes'

export async function isCategoryPage({
  editorSdkProxy,
  collectionsApi,
}: {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
}): Promise<boolean> {
  const result = await getCollectionIdAndPatternOfCurrentDynamicPage({
    editorSdkProxy,
  })
  if (!result) {
    return false
  }
  try {
    const schema = await collectionsApi.get(result.collectionId)
    return isCategoryCollection(schema)
  } catch {
    return false
  }
}
